import React from 'react';
import { createRoot } from 'react-dom/client';

import KanbanApp from './app';

window.initKanbanApp = (container, params) => {
  createRoot(container).render(<KanbanApp {...params} />);
};
